"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrganizationsProducts = void 0;

const utils_1 = require("../utils");

const getOrganizationsProducts = (jilFetch, options) => {
  const setDefaults = _a => {
    var {
      include_created_date = true,
      include_expired = true,
      include_groups_quantity = false,
      include_inactive = false,
      include_legacy_ls_fields = true,
      include_license_activations = true,
      include_license_allocation_info = false,
      include_pricing_data = false
    } = _a,
        args = __rest(_a, ["include_created_date", "include_expired", "include_groups_quantity", "include_inactive", "include_legacy_ls_fields", "include_license_activations", "include_license_allocation_info", "include_pricing_data"]);

    return utils_1.omitIfNil(Object.assign({
      include_created_date,
      include_expired,
      include_groups_quantity,
      include_inactive,
      include_legacy_ls_fields,
      include_license_activations,
      include_license_allocation_info,
      include_pricing_data
    }, args));
  };

  const path = `organizations/${options.orgId}/products${options.productId ? `/${options.productId}` : ''}`;
  const params = setDefaults({
    contract_id: options.contractId,
    include_created_date: options.includeCreatedDate,
    include_expired: options.includeExpired,
    include_groups_quantity: options.includeGroupsQuantity,
    include_inactive: options.includeInactive,
    include_legacy_ls_fields: options.includeLegacyLSFields,
    include_license_activations: options.includeLicenseActivations,
    include_license_allocation_info: options.includeLicenseAllocationInfo,
    include_pricing_data: options.includePricingData,
    license_group_limit: options.licenseGroupLimit
  });
  return jilFetch(path, params, {
    method: 'GET'
  });
};

exports.getOrganizationsProducts = getOrganizationsProducts;